
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import EditReportForm from './EditReportForm';

interface GroupedReport {
  authorId: string;
  year: number;
  quarter: number;
  reports: any[];
  totalSales: number;
  totalAmount: number;
  status: string;
  countries: Set<string>;
}

interface EditReportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  reportGroup: GroupedReport | null;
}

export default function EditReportDialog({ open, onOpenChange, reportGroup }: EditReportDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>Edit Royalty Report</DialogTitle>
          <DialogDescription>
            Edit the quarterly royalty report for Q{reportGroup?.quarter} {reportGroup?.year}.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          {reportGroup && (
            <EditReportForm 
              reportGroup={reportGroup}
              onSuccess={() => onOpenChange(false)} 
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
